module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-06-116ed568c8c99d13c31395d06c924967.jpg";